(function AdzukiExistingFile($, Adzuki)
{
	'use strict';

	const component = {
		emits : ['component-event'],
		inject: {
			formatDuration: {
				default: () => undefined
			},
			formatFileSize: {
				default: () => undefined
			},
			fileIcon: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			}
		},
		props: {
			file: {
				type    : Object,
				required: true,
			},
			asset: {
				type: Object
			},
			media: {
				type: Object
			}
		},
		data() {
			return {
				assetRemoteUrl: null
			};
		},
		template: `
          <div class="existing-confirm-container">
            <div class="existing-file-container">
              <div class="row">
				<div class="col">
					<div class="alert alert-info" role="alert">A file with the file name you are attempting to upload currently exists within your media library. Using the actions below, please confirm what action to complete related to this file.</div>
					<template v-if="file.type.startsWith('image') && asset.path">
						<img
							class="border border-3 rounded-3 border-primary w-50 p-0"
							:src="getMediaSrc"
							:alt="file.name"/>
					</template>

					<template v-else-if="file.type.startsWith('video') && asset.path">
						<div class="file-image-container w-50 mb-2">
							<template v-if="assetRemoteUrl">
								<video crossorigin="anonymous" class="border border-3 rounded-3 border-primary p-0 w-100" controls muted>
									<source :src="assetRemoteUrl">
								</video>
							</template>
						</div>
					</template>

					<template v-else>
						<div class="file-image-container w-50 mb-2">
							<p class="doc-image d-flex align-items-center justify-content-center m-0">
								<i :class="fileIcon(file.name.split('.').pop().toLowerCase())" class="text-txt"></i>
							</p>
							<p class="text-center mt-2 fs-4 text-break">
								<span>{{file.name}}</span>
							</p>
						</div>
					</template>
				</div>
              </div>
              <div class="existing-action-container mt-2">
                <button v-if="$section" class="btn btn-primary me-2" @click="selectExisting">Select Existing File</button>
                <button class="btn btn-outline-primary me-2" @click="uploadAnyway">Upload A Copy</button>
                <button class="btn btn-outline-danger" @click="cancelUpload">Cancel</button>
              </div>
            </div>
          </div>
		`,
		computed: {
			getMediaSrc() {
				let assetPath;
				let fileName;

				if (
					this.asset
					&& this.asset.path
					&& (this.asset.path.startsWith('images') || this.asset.path.startsWith('docs'))
				) {
					if (this.asset.actual_file_name && this.asset.actual_file_name !== '') {
						fileName = this.asset.actual_file_name;
					} else {
						fileName = this.asset.original_file_name;
					}

					assetPath = this.$baseUri + '/' + this.asset.path + fileName;
				}

				if (!assetPath) {
					if (this.assetRemoteUrl) {
						assetPath = this.assetRemoteUrl;
					} else if (this.media && this.media.remote_url) {
						assetPath = this.media.remote_url;
					}
				}

				return assetPath;
			},
		},
		methods: {
			cancelUpload() {
				const eventData = {
					type: 'cancel',
					file: this.file,
				};
				this.$emit('component-event', eventData);
			},
			uploadAnyway() {
				let eventData = {
					type: 'upload',
					file: this.file,
				};
				this.$emit('component-event', eventData);
			},
			selectExisting() {
				let eventData = {
					type : 'select',
					media: this.media,
				};
				this.$emit('component-event', eventData);
			},
		},
		mounted() {
			if (this.media) {
				const mediaId = this.media.id;
				const url     = `${this.$baseUri}/Media/getPublicMediaUrl/${mediaId}`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error getting public url: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.assetRemoteUrl = data.remote_url;
					})
					.catch(error => {
						console.error('Error fetching reviews:', error);
					});
			}
		}
	};

	Adzuki.VueComponents.AdzukiExistingFile = component;
}(jQuery, window.Adzuki || {}));
